// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox-module__checkbox-container--_fUCv{display:flex;align-items:center;gap:10px}.Checkbox-module__checkbox-container--_fUCv .Checkbox-module__checkbox-input--mI7DO{accent-color:#2778ce;cursor:pointer}.Checkbox-module__checkbox-container--_fUCv .Checkbox-module__label--yUAKL{line-height:24px;cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkbox-container": `Checkbox-module__checkbox-container--_fUCv`,
	"checkboxContainer": `Checkbox-module__checkbox-container--_fUCv`,
	"checkbox-input": `Checkbox-module__checkbox-input--mI7DO`,
	"checkboxInput": `Checkbox-module__checkbox-input--mI7DO`,
	"label": `Checkbox-module__label--yUAKL`
};
export default ___CSS_LOADER_EXPORT___;
